import { createStyles, Theme } from '@material-ui/core';

const arrowSize = 20;

const AddToHomeScreenStyles = (theme: Theme) => createStyles({
  safariSaveImg: {
    verticalAlign: `sub`,
  },
  arrowDown: {
    width: 0,
    height: 0,
    borderLeft: `${arrowSize}px solid transparent`,
    borderRight: `${arrowSize}px solid transparent`,
    borderTop: `${arrowSize}px solid #fff`,
    position: `absolute`,
    bottom: -20,
    left: `calc(50% - ${arrowSize}px)`,
  },
  bottomDialog: {
    position: `fixed`,
    bottom: theme.spacing(1) * 4,
    margin: 0,
    overflow: `visible`,
    maxWidth: `85%`,
    borderRadius: theme.spacing(1) / 2,
    textAlign: `center`,
  },
});

export default AddToHomeScreenStyles;
